"use client";
import { useAppDispatch, useAppSelector } from "@/store/store";
import { useEffect, useState } from "react";
import { faqSlice } from "@/store/slices/faqSlice";
import { setSearchQuery } from "@/store/actions/faqActions";
import { NotFound } from "@/components/shared/NotFound";
import { SectionContent } from "@/components/pages/faq/SectionContent";
import { FilteredContent } from "@/components/pages/faq/FilteredContent";
import { useSearchParams } from "next/navigation";

export type FAQPageContent = {
  id: string;
  heading: string;
  items: {
    id: string;
    heading: string;
    content: string;
  }[];
}[];

export type FAQPageType = "commercial" | "academic";

type FAQPageProps = {
  faq: FAQPageContent;
  type: FAQPageType;
};

export const FAQPage = ({ faq, type }: FAQPageProps) => {
  const searchParams = useSearchParams();
  const searchTerm = searchParams.get("search");

  const dispatch = useAppDispatch();
  const filteredItems = useAppSelector((state) => state.faq.filteredItems);
  const search = useAppSelector((state) => state.faq.searchQuery);
  const isSearch = search.length > 3 && filteredItems.length > 0;
  const isNotFound = search.length > 3 && filteredItems.length === 0;

  const [initialTermSet, setInitialTermSet] = useState(false);

  useEffect(() => {
    const allItems: any[] = [];

    faq.forEach(({ items }) => {
      items.forEach((item: any) => allItems.push(item));
    });
    dispatch(faqSlice.actions.set(allItems));
  }, [faq, dispatch]);

  useEffect(() => {
    if (initialTermSet) return;
    setInitialTermSet(true);
    dispatch(setSearchQuery(typeof searchTerm === "string" ? searchTerm : ""));
  }, [dispatch, searchTerm, initialTermSet]);

  const allFaq = faq.map(({ items }) => items).flat();

  return (
    <>
      {isNotFound && <NotFound query={search} hideMd />}
      {!isSearch && <SectionContent faq={faq} isNotFound={isNotFound} query={search} type={type} />}
      {isSearch && <FilteredContent list={filteredItems} />}
    </>
  );
};
